import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useCategory from "../hooks/useCategory";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import "../styles/Categories.css";

const Categories = () => {
  const categories = useCategory();
  const [categoryCounts, setCategoryCounts] = useState({});

  useEffect(() => {
    const getCounts = async () => {
      try {
        const counts = {};
        for (const cat of categories) {
          try {
            const { data } = await axios.get(`/api/v1/products/product-category/${cat.slug}`);
            counts[cat._id] = data?.products?.length || 0;
          } catch {
            counts[cat._id] = 0;
          }
        }
        setCategoryCounts(counts);
      } catch (error) {
        console.log(error);
      }
    };
    if (categories.length > 0) getCounts();
  }, [categories]);

  // Map brand names to known static images as fallback
  const brandImages = {
    'Apple': '/images/Apple-iPhone-15.jpg',
    'Samsung': '/images/zlip3.jpg',
    'OnePlus': '/images/oneplus2.png',
    'Vivo': '/images/vivo.png',
    'Nothing': '/images/nothing1.png',
    'Oppo': '/images/opporeno.jpg',
    'Xiaomi': '/images/redminote11.jpg',
    'Realme': '/images/saimob1.png',
    'Huawei': '/images/samsungs11.jpg',
    'Tecno': '/images/samsungfold.jpg',
  };

  const defaultImg = '/images/iphone15blue.png';

  return (
    <Layout title={"جميع الأقسام - النخبة ستور"}>
      {/* Hero Banner */}
      <div className="categories-hero">
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="categories-hero-bg" />
        <div className="categories-hero-overlay">
          <h1>جميع الأقسام</h1>
          <p>اختر من بين {categories.length} علامة تجارية عالمية</p>
        </div>
      </div>

      <div className="container categories-container">
        <div className="row">
          {categories.map((c) => (
            <div className="col-lg-3 col-md-4 col-sm-6 mt-4 mb-3" key={c._id}>
              <Link to={`/category/${c.slug}`} className="category-card-link">
                <div className="category-card">
                  <div className="category-card-img">
                    <img src={brandImages[c.name] || defaultImg} alt={c.name} />
                  </div>
                  <div className="category-card-body">
                    <h4>{c.name}</h4>
                    <div className="category-card-meta">
                      {categoryCounts[c._id] !== undefined && (
                        <span className="category-count">{categoryCounts[c._id]} منتج</span>
                      )}
                      <span className="category-arrow">←</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Categories;
